import Vue from 'vue';
import Toast from './toast';

Vue.use(Toast);
